// export { LoginPage } from './login';
export { ListFormPage } from './list_form';
export { FormPage } from './form';
export { ListFormResponsePage } from './list_form_response';
export { DetailResponsePage } from './detail_response';


// WEBPACK FOOTER //
// ./src/pages/survey/index.ts